<template>
  <div class="tabs">
    <ul>
      <li><a href="/">Games</a></li>
      <li v-for="(li, index) in list" :key="'tab_link_' + index">
        <router-link :to="li.url">{{ li.text }}</router-link>
      </li>
      <li>{{ getCurrentPage }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PageTabs",
  props: ["list", "currentPage"],
  computed: {
    getCurrentPage() {
      if (this.currentPage) return this.currentPage;
      return "Current page";
    }
  }
};
</script>

<style scoped lang="less">
.tabs {
  text-align: left;
  ul {
    background: white;
    padding: 10px;
    display: inline-block;
    border-radius: 0 14px 14px 0;
  }
  li {
    display: inline-block;
    list-style: none;
    margin-right: 30px;
    &:after {
      content: " >";
      color: #f76331;
    }
    &:last-child {
      font-weight: bold;
      &:after {
        content: "";
        color: #000;
      }
    }
    a {
      color: #f76331;
    }
  }
}
</style>
